<template>
  <v-card flat class="mb-5">
    <v-card-text class="px-7">
      <template v-if="isBuka">
        <div class="mt-5">
          <h2 class="black--text">
            Nilai Pretest dan Posttest
          </h2>
          <v-list>
            <v-list-item class="px-0" v-for="(partisipan, id) in partisipans" :key="id">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" lg="3" class="my-auto">
                    <div class="body-1 font-weight-medium">
                      {{ partisipan.nama || $getDeepObj(partisipan, 'ptk.data.nama') || '' }}
                    </div>
                    <div class="body-2 black--text">
                      <span class="grey--text">NUPTK: </span>{{ $getDeepObj(partisipan, 'ptk.data.nuptk') || '-' }}
                    </div>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <div class="v-subheader theme--light px-0 body-2 indigo--text" style="height: 24px;">
                      Nilai Pretest
                    </div>
                    <div class="black--text grey lighten-3 pa-2">{{ partisipan.n_pretest }}</div>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <div class="v-subheader theme--light px-0 body-2 indigo--text" style="height: 24px;">
                      Nilai PostTest
                    </div>
                    <div class="black--text grey lighten-3 pa-2">{{ partisipan.n_posttest }}</div>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
        <div class="mt-5">
          <div v-for="(jns, jenisId) in jenis" :key="jenisId">
            <h2 class="black--text">
              {{ jns.title }}
            </h2>
            <template v-for="(kelompok, kelompokId) in jns.kelompoks">
              <div :key="kelompokId" class="mb-5">
                <div v-if="kelompok.title" class="mx-3">
                  <span class="font-weight-medium indigo--text" style="font-size: 16px">{{ kelompok.title }}</span>
                  <v-divider class="primary mt-1" style="height: 2.5px; max-height: 2.5px" />
                </div>
                <v-container>
                  <v-list class="py-0" v-if="kelompok.model === 'table'">
                    <v-list-item class="hidden-md-and-down px-0">
                      <v-row class="mt-0">
                        <v-col cols="12" lg="6" class="my-auto py-1">
                          <v-row no-gutters style="flex-wrap: nowrap">
                            <v-col
                              style="min-width: 25px; max-width: 100%"
                              class="flex-grow-0 flex-shrink-0 text-right mr-2 text-right py-1"
                            >
                              &nbsp;
                            </v-col>
                            <v-col
                              style="max-width: 100%"
                              class="flex-grow-1 flex-shrink-0 text-justify py-1 font-weight-medium"
                            >
                              Pertanyaan
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" lg="6" class="my-auto py-1">
                          <v-row>
                            <v-col
                              v-for="(opsi, opsiId) in $getDeepObj(listInstrumen, `${kelompok.key}.0.opsi`) || []"
                              :key="`${jenisId}-${kelompokId}-XX-${opsiId}`"
                              cols="11"
                              offset="1"
                              offset-lg="0"
                              lg="3"
                              class="py-1"
                            >
                              <div class="font-weight-medium">{{ opsi.keterangan }}</div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item
                      v-for="(instrumen, instrumenId) in listInstrumen[kelompok.key] || []"
                      :key="`${kelompokId}-${instrumenId}`"
                      class="mb-2 px-0"
                    >
                      <v-row :class="[instrumenId > 0 ? 'mt-3' : 'mt-0', 'mt-lg-0']">
                        <v-col cols="12" lg="6" class="my-auto">
                          <v-row no-gutters style="flex-wrap: nowrap">
                            <v-col
                              style="min-width: 25px; max-width: 100%"
                              class="flex-grow-0 flex-shrink-0 text-right mr-2 text-right"
                            >
                              {{ instrumen.nomor || instrumenId + 1 }}.
                            </v-col>
                            <v-col style="max-width: 100%" class="flex-grow-1 flex-shrink-0 text-justify">
                              {{ instrumen.keterangan }}
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" lg="6" class="py-0 py-lg-2">
                          <v-row>
                            <v-col
                              v-for="(opsi, opsiId) in instrumen.opsi || []"
                              :key="`${kelompokId}-${instrumenId}-${opsiId}`"
                              cols="11"
                              offset="1"
                              offset-lg="0"
                              lg="3"
                            >
                              <div class="hidden-lg-and-up">{{ opsi.keterangan }}</div>
                              <div class="black--text grey lighten-3 pa-2">
                                {{ values[opsi.k_monev_opsi_psp] || 0 }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </v-list>
                  <v-list v-else>
                    <div
                      v-for="(instrumen, instrumenId) in listInstrumen[kelompok.key] || []"
                      :key="`${kelompokId}-${instrumenId}`"
                    >
                      <v-divider v-if="instrumenId !== 0" class="my-5" />
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <div class="px-0 body-2 indigo--text font-weight-medium" style="min-height: 24px">
                            {{ instrumen.keterangan || '-' }}
                          </div>
                          <v-list v-if="instrumen.tipe === 'textarea'">
                            <div class="black--text grey lighten-3 pa-2">
                              {{ values[`instrumen-${instrumen.k_monev_instrumen_psp}`] }}
                            </div>
                          </v-list>
                          <v-list class="py-0">
                            <v-list-item
                              class="px-0 mt-2 mt-lg-0"
                              v-for="(opsi, opsiId) in instrumen.opsi || []"
                              :key="`${kelompokId}-${instrumenId}-${opsiId}`"
                            >
                              <v-list-item-content>
                                <v-row>
                                  <v-col cols="12" :lg="getGrid('opsi', instrumen)" class="my-auto py-0 py-lg-2">
                                    {{ opsi.keterangan }}
                                  </v-col>
                                  <v-col cols="12" :lg="getGrid('rekap', instrumen)" class="py-1 py-lg-2">
                                    <div class="black--text grey lighten-3 pa-2">
                                      {{ values[opsi.k_monev_opsi_psp] || 0 }}
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </v-list>
                </v-container>
              </div>
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-icon x-large color="grey" style="font-size: 6rem" class="mb-3">mdi-file-alert</v-icon>
            <h2>Laporan IHT Tidak Tersedia</h2>
            <div class="body-2">
              Hal ini dikarenakan pihak terkait belum mengirimkan laporannya
            </div>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'IhtEvaluasi',
  props: {
    laporan: {
      type: Object,
      default: () => {},
    },
    meta: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('preferensi', {
      isBalai: (state) => (state.data && state.data.balai) || false,
    }),

    isBuka() {
      return this.laporan.k_verval_psp > 1;
    },

    partisipans() {
      return this.$getDeepObj(this.laporan, 'psp_monev_partisipans.data') || [];
    },

    jenis() {
      return [
        {
          title: 'Evaluasi Pelaksanaan',
          kelompoks: [
            {
              title: '',
              key: 'smk-iht',
            },
            {
              title:
                'Menurut Anda, bagaimana kesesuaian durasi waktu untuk setiap materi? Sesuaikan dengan materi IHT (15 Materi)',
              key: 'smk-iht-1',
              model: 'table',
            },
            {
              title: 'Menurut Anda, materi apa saja yang masih membutuhkan penguatan dari segi substansi materi?',
              key: 'smk-iht-2',
              model: 'table',
            },
            {
              title: '',
              key: 'smk-iht-3',
            },
            {
              title: 'Menurut Anda, materi apa saja yang masih membutuhkan penguatan dari segi substansi materi?',
              key: 'smk-iht-4',
              model: 'table',
            },
            {
              title: '',
              key: 'smk-iht-5',
            },
          ],
        },
        {
          title: 'Evaluasi PIP',
          kelompoks: [
            {
              title: '',
              key: 'smk-pip',
            },
            {
              title:
                'Berikut ini terdapat sejumlah pernyataan terkait aspek kinerja Fasilitator/Pengajar  dalam IHT SMK PK. Berilah penilaian dalam rentang 1 (kurang baik), 2 (cukup baik), 3 (baik), 4 (sangat baik) terhadap performa Fasilitator/Pengajar pada materi ini',
              key: 'smk-pip-1',
              model: 'table',
            },
            {
              title: '',
              key: 'smk-pip-2',
            },
          ],
        },
      ];
    },

    pspMonevInstrumens() {
      return this.$getDeepObj(this.laporan, 'psp_monev_instrumens.data') || [];
    },

    values() {
      let values = {};
      const pspMonevInstrumens = this.$getDeepObj(this.laporan, 'psp_monev_instrumens.data') || [];

      for (const pspMonevIns of pspMonevInstrumens) {
        if (pspMonevIns.rekap !== null) {
          values[pspMonevIns.k_monev_opsi_psp] = pspMonevIns.rekap || 0;
        } else {
          values[`instrumen-${pspMonevIns.k_monev_instrumen_psp}`] = pspMonevIns.catatan || '';
        }
      }

      return values;
    },

    listInstrumen() {
      return this.meta.instrumen || {};
    },
  },
  methods: {
    getGrid(tipe, instrumen) {
      let init = { opsi: 2, rekap: 3 };
      if ([201, 262, 302, 303, 304, 305, 306, 307, 308, 309].includes(+instrumen.k_monev_instrumen_psp)) {
        init = { opsi: 6, rekap: 3 };
      }

      return init[tipe];
    },
  },
};
</script>

<style scoped></style>
